<template>
  <div>
    <div
      class="content select-group"
      :class="['', select_value != '' && 'edited']"
      data-open-in="sheet"
    >
      <f7-list-item smart-select :smart-select-params="{openIn: 'sheet'}">
        <select v-model="select_value" @change="changeUpdate(select_value)">
          <option
            v-for="(select_list,key) in select_lists"
            :key="key"
            v-bind:value="select_list.value"
          >{{ select_list.name }}</option>
        </select>
        <div class="item-content">
          <div class="item-inner">
            <div class="item-title"></div>
            <div class="item-after">選択してください。</div>
          </div>
        </div>
      </f7-list-item>
    </div>
  </div>
</template>

<script>
export default {
  props: ['select_lists'],
  data() {
    return {
      select_value: '',
      update_select: ''
    };
  },
  methods: {
    changeUpdate(select_value) {
      //console.log(select_value);
      this.$emit('update_select', select_value);
    }
  }
};
</script>

<style lang="less" scoped>
.item-inner {
  text-indent: 0.12rem;
  width: 3.2rem;
  position: relative;
  top: 0rem;
}
.item-after {
  font-size: unset;
  position: relative;
  font-size: 0.16rem;
  border-radius: 0.05rem;
  height: 0.5rem;
  text-indent: 0.12rem;
  top: 0.25rem;
  overflow: visible;
  color: #707070;
}
.row {
  .select-group {
    position: relative;
    border: 0.01rem solid #00a4b0;
    background-repeat: no-repeat;
    //display: inline-block;
    width: 3.19rem;
    background: #ffe5e5;
    border: 0.01rem solid #00a4b0;
    color: #707070;
    opacity: 1;
    border-radius: 0.05rem;
    padding: 0;
  }
  .select-group:after {
    position: absolute;
    top: 0;
    right: 5%;
    bottom: 0;
    width: 0;
    height: 0;
    margin: auto;
    content: '';
    border-top: 0.07rem solid #00a4b0;
    border-right: 0.07rem solid transparent;
    border-left: 0.07rem solid transparent;
    pointer-events: none;
  }
  .edited {
    background: #ffffff;
    color: #333333;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Input/cSelect.vue